/**
 * Die eigene Wahl der Feldkoordinaten (`R14`, Entscheidung des Users 2026-10-13).
 *
 * **Jeder Spieler schaltet die Koordinaten für sich**, nur im eigenen Browser. Der Haken des Hosts
 * (`showCoordinates`, **E30**) bleibt der **Startwert** für alle. Die eigene Wahl merkt sich der
 * Browser **je Partie**, damit sie ein Neuladen überlebt und keine andere Partie beeinflusst.
 *
 * `localStorage` kann werfen (privates Fenster, gesperrte Website-Daten). Dann gibt es keine
 * eigene Wahl, und es gilt der Haken des Hosts — eine Anzeige darf daran nicht kippen.
 */

const PREFIX = 'flaghex.coordinates.';

/** Die eigene Wahl für diese Partie, oder `undefined`, wenn es keine gibt. */
export function readCoordinatesChoice(gameId: string): boolean | undefined {
  try {
    const raw = window.localStorage.getItem(PREFIX + gameId);
    return raw === 'on' ? true : raw === 'off' ? false : undefined;
  } catch {
    return undefined;
  }
}

export function writeCoordinatesChoice(gameId: string, value: boolean): void {
  try {
    window.localStorage.setItem(PREFIX + gameId, value ? 'on' : 'off');
  } catch {
    // Ohne Speicher gilt die Wahl nur bis zum Neuladen — mehr verspricht der Schalter nicht.
  }
}
